import { IPublicClientApplication } from '@azure/msal-browser'
import { BlockBlobClient } from '@azure/storage-blob'
import { FileWithPath } from '@mantine/dropzone'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import { getSasToken } from '../data/azure.service'
import { FileWithUrl } from '../models/FileWithUrl'

export async function uploadBlobFromFile(
  containerName: string,
  file: FileWithPath,
  msalInstance: IPublicClientApplication,
): Promise<string> {
  const accountName = 'hiddengemzstorage'

  // Get the file extension from the original file
  const fileExtension = file.name.split('.').pop()?.toLowerCase() || 'jpg'
  const blobName = `${uuid()}.${fileExtension}`

  try {
    // Request SAS token from backend
    const sasResponse = await getSasToken(msalInstance, containerName, blobName)

    // Create blob client with the SAS token
    const blobClient = new BlockBlobClient(sasResponse.blobUrl)

    // Upload the file
    await blobClient.uploadData(file)

    // Return the permanent URL (without SAS token)
    return `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`
  } catch (error) {
    console.error('Error uploading file:', error)
    throw new Error('Failed to upload file')
  }
}

export const downloadFiles = async (files: FileWithUrl[]) => {
  try {
    const downloadPromises = files.map((file) =>
      axios.get(file.url, { responseType: 'blob' }),
    )
    const responses = await Promise.all(downloadPromises)
    responses.forEach((response, index) => {
      const file = files.find((f) => f.url === response.config.url)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', file?.fileName || `file_${index + 1}.jpg`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    })
  } catch (error) {
    console.error('Error downloading files:', error)
  }
}
